import { getIsLauncher } from "@mirage/service-experimentation/useDualMode";
import { atom } from "jotai";

const isAlwaysOpen = () => getIsLauncher();

// The base atom that holds the actual state
const baseTypeaheadIsOpenAtom = atom(isAlwaysOpen() ? true : false);

// This is a derived atom that allows us to ensure that the typeahead/omnibox is always open in the launcher
export const typeaheadIsOpenAtom = atom(
  (get) => get(baseTypeaheadIsOpenAtom),
  (get, set, newValue: boolean) => {
    if (isAlwaysOpen() && newValue === false) {
      set(baseTypeaheadIsOpenAtom, true);
    } else {
      set(baseTypeaheadIsOpenAtom, newValue);
    }
  },
);
